export const enumDecoder = (source: Array<any>, code: number | string) => {
  let result = null;
  source.map((value) => {
    if (value.value == code) result = value;
  });
  return result;
};

type decoderSource = {
  source: Array<any>;
  code: number | string;
  property: string;
};

export const customEnumDecoder = ({
  source,
  code,
  property = "value",
}: decoderSource) => {
  let result = null;
  if (!source) return {};
  source.map((value) => {
    if (value[property] == code) result = value;
  });
  return result ? result : {};
};

export const educationToString = (source: any) => {
  if (source) {
    return `${source.last_degree_of_education || ""} ${source.major || ""}`;
  } else {
    return "not_declared";
  }
};

export const removeX10 = (source: Array<any>) => {
  const result = [] as any;
  source.forEach((record) => {
    let data = {};
    Object.entries(record).map(([key, value]: any) => {
      data = {
        [key.includes("_x10") ? key.replace("_x10", "") : key]: key.includes(
          "_x10"
        )
          ? value / 10
          : value,
        ...data,
      };
    });
    result.push(data);
  });
  return result;
};

export const BAColorDecoder = (
  value: number,
  rules: Array<number>,
  colors: Array<any>
) => {
  if (
    value == null ||
    rules == null ||
    colors == null ||
    rules.length == 0 ||
    colors.length < rules.length
  )
    return null;
  for (let i = 0; i < rules.length; i++) {
    if (value < rules[i]) return colors[i];
  }
  return colors[rules.length];
};

export const isEmptyObject = (object: any) => {
  return Object.keys(object).length === 0;
};

export const isNullOrEmptyString = (val: string) => {
  return val === null || val === "";
};

export const fixNumber = (value: number, precision = 2): number => {
  const isNegative = value < 0;
  value = Math.abs(value);
  const newValue = Number(
    value
      .toString()
      .match(new RegExp("^-?\\d+(?:.\\d{0," + precision + "})?"))?.[0] || "0"
  );
  return isNegative ? -newValue : newValue;
};

// export const findParamById = (
//   params: HMIParamsType,
//   id: number
// ): { key: HMIKeyType; param: IHMIParams } | undefined => {
//   const entry = Object.entries(params).find(([_key, param]) => param.id === id);
//   if (entry) {
//     const [key, param] = entry;
//     return { key: key as HMIKeyType, param };
//   }
//   return undefined;
// };
